import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect } from "react";



const Content = () => {
    const { t } = useTranslation("common");
    const { type } = useParams();
    const navigate = useNavigate();
    
    useEffect(()=>{
        if(!(type == "success" || type == "error")) {
            navigate("/notfound", { replace: true });
        }
    },[type, navigate]);

    let param:any = "success";
    if (type !== undefined) {
        param = type;
    }
    let days = localStorage.getItem("client") === "EDM" ? "90" : "45";
    let url:any = localStorage.getItem("loginUrl") ? localStorage.getItem("loginUrl") : "";
    return (
        <div className="row justify-content-center pt-5">
            <div className="h-67vh col-10">
                <div className={`pt-5 pb-25 custom-bg text-dark text-center`}>
                {param === "success" ? (<div><div> {t("reg_success")}{days} {t("reg_success_day_count")}</div><br/><div>{t("reg_success_p1")} {days === "90" ? t("iot") : t("wyse_label")} {t("console")} <a href={url} rel="noopener noreferrer" target="_blank">{t("reg_success_here")}</a> {t("reg_success_p2")}</div></div>): (<div>{t("reg_error")}</div>)}
                    <div className="mb-25 pt-2 pb-20">
                        {t("help_text")} <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/support/home/en-us/product-support/product/wyse-wms/overview">{days === "90" ? t("iot") : t("wyse_label")} {t("support")}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function Confirmation() {
    return (
        <div className="wrapper">
            <Header />
            <Content />
            <Footer />
        </div>
    );
}